import { render } from "./UserViewSignIn.vue?vue&type=template&id=9d5285b4&scoped=true"
import script from "./UserViewSignIn.vue?vue&type=script&lang=js"
export * from "./UserViewSignIn.vue?vue&type=script&lang=js"

import "./UserViewSignIn.vue?vue&type=style&index=0&id=9d5285b4&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5285b4"]])

export default __exports__